import Result_img1 from "../../images/result.png";
import Result_img2 from "../../images/result2.png";

const ItemsResult = [
    {id: 1, vector: Result_img1, facebook: 'facebook' , Instagram: 'instagram' , Twitter: 'twitter'},
    {id: 2, vector: Result_img2, facebook: 'facebook' , Instagram: 'instagram' , Twitter: 'twitter'},
    
]
export default ItemsResult